import PageService from '@/common/api/page'
import {
  GET_PAGE_FIXED,
  GET_PAGE_ADDED,
  GET_PAGE_PREVIEW
} from './actions'
import {
} from './mutations'

const state = {
}

const getters = {
}

const actions = {
  [GET_PAGE_FIXED] (context, { code, params = {} }) {
    return new Promise((resolve, reject) => {
      PageService.getFixed(code, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_PAGE_ADDED] (context, { code, params = {} }) {
    return new Promise((resolve, reject) => {
      PageService.getAdded(code, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_PAGE_PREVIEW] (context, { code, params = {} }) {
    return new Promise((resolve, reject) => {
      PageService.getPreview(code, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
